import { Font } from "@react-pdf/renderer";
import { getPdfFontBoldSrc, getPdfFontRegularSrc } from "./pdfAssets";

let registered = false;

/** Keep whole words intact — no mid-word hyphen breaks (e.g. "Fu-\nnamos"). */
function keepWholeWord(word: string): string[] {
  return [word];
}

export function registerMetricsPdfFonts(): void {
  if (registered) return;
  Font.register({
    family: "DM Sans",
    fonts: [
      { src: getPdfFontRegularSrc(), fontWeight: "normal" },
      { src: getPdfFontBoldSrc(), fontWeight: "bold" },
    ],
  });
  Font.registerHyphenationCallback(keepWholeWord);
  registered = true;
}
